module.exports = __webpack_public_path__ + "img/img16.dfa14bbc.png";